module.exports = __webpack_public_path__ + "img/thumbnail_Saiga_f_normal.68913708.png";